import getApiClient from '../../../plugins/api-client'

export default {
  loadContents: function () {
    const api = getApiClient(this.$store)
    const contents = this.contents

    api.get('/content_datas', {
      params: {
        id: contents,
      },
    })
      .then(result => {
        this.localContents = result.data['hydra:member']
      })
  },

  save: function () {
    const api = getApiClient(this.$store)
    const contents = this.localContents

    api.post('/content_data/batch_update', contents)
      .then(result => {
        console.info(result.data)
      })
      .catch(error => {
        console.error(error)
      })
  },
}
